import { render } from "./IntroductionSlide.vue?vue&type=template&id=61be8b2d&scoped=true"
import script from "./IntroductionSlide.vue?vue&type=script&lang=js"
export * from "./IntroductionSlide.vue?vue&type=script&lang=js"

import "./IntroductionSlide.vue?vue&type=style&index=0&id=61be8b2d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Admin\\source\\MFVK\\menu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61be8b2d"]])

export default __exports__